import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
  reverseOrderOn?: "mobile" | "desktop";
  startColsDesktop?: 1 | 2 | 3 | 4 | 5 | undefined;
}

const GridPresetTwoThirds = ({
  children,
  reverseOrderOn,
  startColsDesktop,
}: GridRowProps) => (
  <GridCell
    reverseOrderOn={reverseOrderOn}
    spanColsDesktop={8}
    startColsDesktop={startColsDesktop}
    spanColsTablet={6}
    spanColsMobile={6}
  >
    {children}
  </GridCell>
);

export default GridPresetTwoThirds;
